export default "__VITE_ASSET__B7Ojxc$I__"